"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _index = _interopRequireDefault(require("@/components/NavBarTop/index.vue"));
var _RightPanel = _interopRequireDefault(require("@/components/RightPanel"));
var _components = require("./components");
var _TopMenu = _interopRequireDefault(require("./components/TopMenu"));
var _ResizeHandler = _interopRequireDefault(require("./mixin/ResizeHandler"));
var _vuex = require("vuex");
var _resetPassword = _interopRequireDefault(require("@/componentsBuz/ResetPassword/resetPassword"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 修改密码
var _default = exports.default = {
  name: 'Layout',
  components: {
    AppMain: _components.AppMain,
    Navbar: _index.default,
    RightPanel: _RightPanel.default,
    Settings: _components.Settings,
    Sidebar: _components.Sidebar,
    TagsView: _components.TagsView,
    TopMenu: _TopMenu.default,
    resetPassword: _resetPassword.default
  },
  mixins: [_ResizeHandler.default],
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapState)({
    sidebar: function sidebar(state) {
      return state.app.sidebar;
    },
    device: function device(state) {
      return state.app.device;
    },
    showSettings: function showSettings(state) {
      return state.settings.showSettings;
    },
    needTagsView: function needTagsView(state) {
      return state.settings.tagsView;
    },
    fixedHeader: function fixedHeader(state) {
      return state.settings.fixedHeader;
    }
  })), {}, {
    classObj: function classObj() {
      return {
        isShowSidebar: !this.sidebar.isShow,
        // hideSidebar: !this.sidebar.opened,
        // openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      };
    },
    menuList: function menuList() {
      return [];
    }
  }, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  data: function data() {
    return {
      // 建立的连接
      ws: null,
      // 是否真正建立连接
      lockReconnect: false,
      // 30秒一次心跳
      timeout: 28 * 1000,
      // 心跳心跳倒计时
      timeoutObj: null,
      // 心跳倒计时
      serverTimeoutObj: null,
      // 断开 重连倒计时
      timeoutnum: null,
      // 端口
      port: 80,
      reconnectTime: 30 * 1000 * 60 * 60 // 重连失败，半小时重连一次
    };
  },
  created: function created() {},
  destroyed: function destroyed() {},
  methods: {
    handleClickOutside: function handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', {
        withoutAnimation: false
      });
    },
    initSocket: function initSocket() {
      // 建立连接 （线上环境）
      var url = "".concat(location.protocol === 'https:' ? 'wss' : 'ws', "://").concat(location.hostname, ":").concat(this.port, "/websocket/") + new Date().getTime();
      this.ws = new WebSocket(url);
      this.ws.onopen = this.onopen;
      this.ws.onmessage = this.onmessage;
      this.ws.onclose = this.onclose;
      this.ws.onerror = this.onerror;
    },
    reconnect: function reconnect() {
      // 重新连接
      var that = this;
      if (that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      // 没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function () {
        // 新连接
        that.initSocket();
        that.lockReconnect = false;
      }, that.reconnectTime);
    },
    reset: function reset() {
      // 重置心跳
      var that = this;
      // 清除时间
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      // 重启心跳
      that.start();
    },
    start: function start() {
      // 开启心跳
      var self = this;
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
      self.timeoutObj = setTimeout(function () {
        // 这里发送一个心跳，后端收到后，返回一个心跳消息，
        if (self.ws.readyState === 1) {
          // 如果连接正常
          self.ws.send('heartCheck');
        } else {
          // 否则重连
          self.reconnect();
        }
        self.serverTimeoutObj = setTimeout(function () {
          // 超时关闭
          self.ws.close();
        }, self.timeout);
      }, self.timeout);
    },
    onopen: function onopen() {
      // 开启心跳
      this.start();
    },
    onmessage: function onmessage(e) {
      // 收到服务器信息，心跳重置
      // console.log('收到服务器信息，心跳重置', e)
      if (e.data !== 'heartCheck') {
        this.$notify({
          title: '升级通知',
          type: 'warning',
          position: 'bottom-right',
          dangerouslyUseHTMLString: true,
          duration: 60000,
          message: '<strong style="color: red;">两个小时后系统将升级，请及时做好数据保存！</strong>'
        });
      }
      this.reset();
    },
    onclose: function onclose(e) {
      // 重连
      this.reconnect();
    },
    onerror: function onerror(e) {
      // 重连
      this.reconnect();
    }
  }
};